// Client-side named watchlists for guests (no account required).
// Mirrors the authenticated API shape: { lists: [{ id, name, players: [...] }] }.
const KEY = "sl_guest_watchlists_v1";
export const GUEST_LIMITS = { lists: 1, per_list: 3 };

function makeDefault() {
  return { lists: [{ id: "default", name: "My Watchlist", players: [] }] };
}

function read() {
  try {
    const d = JSON.parse(localStorage.getItem(KEY));
    if (d && Array.isArray(d.lists) && d.lists.length) return d;
  } catch (e) {
    console.warn("[guestWatchlists] corrupt/empty storage, using default:", e);
  }
  return makeDefault();
}

function write(d) {
  localStorage.setItem(KEY, JSON.stringify(d));
  window.dispatchEvent(new Event("sl-guest-wl"));
}

const mini = (p) => ({
  id: p.id, name: p.name, league: p.league,
  team_abbr: p.team_abbr, position: p.position,
  status: p.status, status_note: p.status_note || "",
});

export const guestWL = {
  get: read,
  createList(name) {
    const d = read();
    if (d.lists.length >= GUEST_LIMITS.lists)
      throw new Error(`Guest mode includes ${GUEST_LIMITS.lists} watchlist. Create a free account for more.`);
    d.lists.push({ id: crypto.randomUUID(), name: (name || "New list").slice(0, 40), players: [] });
    write(d);
  },
  renameList(id, name) {
    const d = read();
    const l = d.lists.find((x) => x.id === id);
    if (l) l.name = (name || l.name).slice(0, 40);
    write(d);
  },
  deleteList(id) {
    const d = read();
    d.lists = d.lists.filter((x) => x.id !== id);
    if (!d.lists.length) d.lists = makeDefault().lists;
    write(d);
  },
  addPlayer(listId, player) {
    const d = read();
    const l = d.lists.find((x) => x.id === listId) || d.lists[0];
    if (l.players.some((p) => p.id === player.id)) return;
    if (l.players.length >= GUEST_LIMITS.per_list)
      throw new Error(`Guest lists hold ${GUEST_LIMITS.per_list} players. Create a free account for bigger lists.`);
    l.players.push(mini(player));
    write(d);
  },
  removePlayer(listId, playerId) {
    const d = read();
    const l = d.lists.find((x) => x.id === listId);
    if (l) l.players = l.players.filter((p) => p.id !== playerId);
    write(d);
  },
  toggleDefault(player) {
    const d = read();
    const has = d.lists.some((l) => l.players.some((p) => p.id === player.id));
    if (has) d.lists.forEach((l) => (l.players = l.players.filter((p) => p.id !== player.id)));
    else d.lists[0].players.push(mini(player));
    write(d);
    return !has;
  },
  hasData() {
    return read().lists.some((l) => l.players.length);
  },
  snapshot() {
    return { lists: read().lists.map((l) => ({ name: l.name, player_ids: l.players.map((p) => p.id) })) };
  },
  clear() {
    localStorage.removeItem(KEY);
    window.dispatchEvent(new Event("sl-guest-wl"));
  },
};
